import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Parser as HtmlToReactParser } from "html-to-react";

import { SolarInsights } from "../../../utils/apis/homepage/index"; 
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";
import "./Tech_Insights.css";
import Blogs_card from "../../blogs/blogs_card/Blogs_card";

const FALLBACK_BLOG_DATA = [

];

const htmlToReactParser = new HtmlToReactParser();

const Tech_Insights = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);
  const [techInsight, setTechInsight] = useState([]);

  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const getTechInsights = useCallback(async () => {
    try {
      const res = await SolarInsights(); 
      if (res?.success && res.data?.length > 0) {
        setTechInsight(res.data);
      } else {
        setTechInsight(FALLBACK_BLOG_DATA);
      }
    } catch (error) {
      console.error("Failed to fetch tech insights:", error);
      setTechInsight(FALLBACK_BLOG_DATA);
    }
  }, []);

  useEffect(() => {
    getTechInsights();
  }, [getTechInsights]);

  return (
    <section className="Tech_Insights">
      <div className="container">
        <Common_heading
          title="Tech Insights & Industry Updates"
          subtitle="Expert knowledge, breaking tech trends, and engineering insights to keep your business ahead of the digital curve."
        />
        
        <Blogs_card
            blog={techInsight}
            handleServiceClick={handleServiceClick}
            htmlToReactParser={htmlToReactParser}
            IMG_URL={IMG_URL}
            IDS={IDS}
          />

        <div className="view_all_section">
          <div className="view_line"></div>
          <button className="view_all_btn" onClick={() => navigate("/blog")}>
            View all
          </button>
        </div>
      </div>
    </section>
  );
};

export default Tech_Insights;